import { fuelType } from '../constants/classificators';

export const isHydrogen = (fuel) => fuel === fuelType.HYDROGEN;
